module.exports = __webpack_public_path__ + "img/CLS-P-530.71439564.svg";